import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import TitleHeader from "../TitleHeader";
import ProductCard from "../ProductCard";
import CommonButton from "../../../../components/button/CommonButton";
import { appApiHandler } from "../../../../api/appApiHandler";
import { enrichProductsWithColors } from "../../../../utils/productInfo";
import useHorizontalWheel from "../../../../hooks/useHorizontalWheel";
import { scrollProductStripChunk } from "../../../../utils/productStripScroll";
import "./NewArrivals.css";

const NewArrivals = ({
  title = "New Arrivals",
  subtitle = "Just landed in our store",
  onPress,
  showViewAll = true,
  products,
  sectionClassName = "new-arrivals",
  stripScrollSingleStep = false,
}) => {
  const navigate = useNavigate();
  const scrollerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useHorizontalWheel(scrollerRef, {
    axisRatio: stripScrollSingleStep ? 0.88 : 0.72,
    // mapWheelYToHorizontal: !stripScrollSingleStep,
    mapWheelYToHorizontal: true,
  
    // wheelYVsXRatio: 0.55,
    wheelYVsXRatio: 0.3,
  });

  const updateArrows = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const { scrollLeft, scrollWidth, clientWidth } = scroller;
    setCanScrollLeft(scrollLeft > 4);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 4);
  }, []);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    updateArrows();
    scroller.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      scroller.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [updateArrows, products]);

  const scrollBy = (direction) => {
    scrollProductStripChunk(scrollerRef.current, direction);
  };

  return (
    <section className={sectionClassName}>
      <TitleHeader title={title} subtitle={subtitle} twoTone />

      <div className="new-arrivals__container">
        {canScrollLeft && (
          <button
            type="button"
            className="new-arrivals__nav new-arrivals__nav--prev"
            onClick={() => scrollBy(-1)}
            aria-label="Previous"
          >
            <FaChevronLeft />
          </button>
        )}

        <div
          className={`new-arrivals__scroller${stripScrollSingleStep ? " new-arrivals__scroller--snap-single" : ""
            }`}
          ref={scrollerRef}
          data-strip-mode={stripScrollSingleStep ? "single-step" : undefined}
        >
          {products.map((item) => (
            <div key={item?._id} className="new-arrivals__item">
              <ProductCard item={item} variant="strip" singleImage />
            </div>
          ))}
        </div>

        {canScrollRight && (
          <button
            type="button"
            className="new-arrivals__nav new-arrivals__nav--next"
            onClick={() => scrollBy(1)}
            aria-label="Next"
          >
            <FaChevronRight />
          </button>
        )}
      </div>

      {showViewAll && (
        <div className="new-arrivals__view-all">
          <CommonButton
            title="VIEW ALL"
            onPress={() => {
              if (onPress) {
                onPress();
              } else {
                navigate(`/category`);
              }
            }}
            customClassName="home-view-all-button"
          />
        </div>
      )}
    </section>
  );
};

export default NewArrivals;
